import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { FileHistoryItem } from "@/types/file-history";

interface RestoreConfirmDialogProps {
  target: FileHistoryItem | null;
  isRestoring: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("ko-KR");
}

export function RestoreConfirmDialog({
  target,
  isRestoring,
  onConfirm,
  onCancel,
}: RestoreConfirmDialogProps) {
  return (
    <Dialog
      open={Boolean(target)}
      onOpenChange={(open) => {
        if (!open && !isRestoring) onCancel();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>이 버전으로 복원할까요?</DialogTitle>
          <DialogDescription>
            현재 파일 내용은 새 버전으로 자동 백업되고, 선택한 버전은 그대로
            유지됩니다. 복원 후에도 되돌릴 수 있습니다.
          </DialogDescription>
        </DialogHeader>
        {target && (
          <div className="rounded-md border bg-muted/30 p-3 text-sm">
            <div className="font-medium">{target.title || "제목 없음"}</div>
            <div className="mt-1 text-xs text-muted-foreground">
              생성 {formatDateTime(target.createdAt)}
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={isRestoring}>
            취소
          </Button>
          <Button onClick={onConfirm} disabled={isRestoring}>
            {isRestoring ? "복원 중..." : "복원"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
